
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';

export const ErrorPrefix = {
  Authentication: 'AUTH',
AuthenticationInvalidFormat: 'AUTH.IFMT',
Authorization: 'AZ',
AuthorizationInvalidFormat: 'AZ.IFMT',
Custom: 'CUS',
ConstraintViolation: 'CV',
InputValidation: 'IV',
InputValidationInvalidFormat: 'IV.IFMT',
InputValidationRequired: 'IV.RQ',
InputValidationSmallerThan: 'IV.ST',
InputValidationGreaterThan: 'IV.GT',
NotSupportedAppVersion: 'NSAV',
System: 'SYS',
};

export const apiCall = async ({ query, variables, fragments }) => {
  let fragmentStr = '';
  if (fragments) {
    fragmentStr = Object.keys(fragments).reduce((agg, val) => {
      agg += val + ' {\n' + fragments[val].join('\n') + '\n}';
      return agg;
    }, '');
  }

  try {
    const config = Amplify.getConfig();
    const endpoint = config.API?.GraphQL?.endpoint;

    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(idToken ? { Authorization: idToken } : {}),
      },
      body: JSON.stringify({
        query: query.replace('...fragments', fragmentStr),
        variables,
      }),
    });

    const json = await response.json();

    if (json.errors) {
      const errors = json.errors.map(({ extensions, message }) => ({
        message,
        inputs: extensions?.inputs,
        affected: extensions?.affected,
        reason: extensions?.reason,
      }));
      return { success: false, errors };
    }

    return { success: true, data: Object.values(json.data)[0] };
  } catch (e) {
    if (e.errors) {
      const errors = e.errors.map(({ extensions, message }) => ({
        message,
        inputs: extensions?.inputs,
        affected: extensions?.affected,
        reason: extensions?.reason,
      }));
      return { success: false, errors };
    }

    return { success: false, message: 'Unknown error' };
  }
};
  